import { Component, Input, OnInit, EventEmitter, Output, ViewEncapsulation, ViewChild, ElementRef, NgZone, QueryList, AfterViewInit, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';


import { InfoModalComponent } from '../popup-modals/info-modal/info-modal.component';
import { CameraComponent } from '../camera/camera.component';
import { DocUploadService } from '../../services/doc-upload.service';

declare var $: any;
@Component({
    selector: 'ntb-doc-upload-popup',
    template: require('./doc-upload-popup.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    styles: [require('./doc-upload-popup.component.css')],
    providers: [DocUploadService],
    encapsulation: ViewEncapsulation.None,
})
export class DocUploadPopupComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() docUploadData: any;
    @Input() isValid: boolean;
    @Input() visaType: string;
    @Input() id1: string;
    @ViewChild('rootEle') rootRef: ElementRef;
    @ViewChild('fileUploadEle') fileUploadEle: ElementRef;
    @ViewChildren(CameraComponent) camera: QueryList<CameraComponent>;
    currentSliderIndex: string;
    currentCamera: CameraComponent;
    cameraList: CameraComponent[];
    currentTabIndex: any;
    @Output() documentActionEmit: EventEmitter<any> = new EventEmitter<any>();
    @Input() index;
    @ViewChild('docOverviewModal') docOverviewModal: InfoModalComponent;
    @Output() onChildClick: EventEmitter<string> = new EventEmitter<string>();
    file: any;
    typeVisa: string;
    @Input() emiratesVisaBValid3: boolean;
    @Input() emirateVisaFValid2: boolean;   
    @Input() proofOfAddressValid1:boolean;
    
    docPreviewPopup = {
        message: '',
    }
    docUploadDropdown = {

    }
    isFileIndexes(files) {
        let mappedFiles = [];
        if (files) {
            mappedFiles = files.map(file => file.index)
        }
        return mappedFiles.indexOf(this.currentSliderIndex) == -1;
    }

    // @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();
    constructor(private zone: NgZone, private docService: DocUploadService) { }
    show() {
        $(this.rootRef.nativeElement).modal('show');
    }

    hide() {
        $(this.rootRef.nativeElement).modal('hide');
    }

    openFileUpload(index, visaType) {
        this.typeVisa = visaType;
        $('#fileUploadEle' + index).click();
    }

    docCameraPreview(id1) {
        let index = 0;
        let arr = [1,2,3].filter(function (item) { return item != id1 });
        if (arr.length < 3) {
            let ele1 = document.getElementById('popover__wrapper1');
            if(ele1)
            ele1.style.display = "none";
           
            let ele2 = document.getElementById('popover__wrapper2');
            if(ele2)
            ele2.style.display = "none";

            let ele3 = document.getElementById('popover__wrapper3');
            if(ele3)
            ele3.style.display = "none";
        }
        let ele = document.getElementById('popover__wrapper' + id1);
        ele.style.display = "block";

        this.currentCamera = this.cameraList[index]
        if (this.currentTabIndex == index) {
            this.currentTabIndex = '-1'
            this.currentCamera.closeCamera();
            return;
        }
        if (this.cameraList[this.currentTabIndex])
            this.cameraList[this.currentTabIndex].closeCamera();

        this.currentTabIndex = index;
        this.cameraList[index].loadCamera();
    }
    ngOnInit() {


    }

    resetCurrentCamera() {
        this.currentTabIndex = '-1';
        if (this.currentCamera)
            this.currentCamera.closeCamera();
    }

    getSnapImage(url) {
        this.resetCurrentCamera();
        if (this.docUploadData.docInfo) {
            this.docService.renderFile(url, this.docUploadData.docInfo, true);
        }
    }
    ngAfterViewInit() {


    }

    showDocumentPreview() {
        if (this.docUploadData.docInfo.files[0].fileType == 'pdf') {
            this.docService.getPdfFile(this.docUploadData.docInfo.files[0].pdfSrc, this.docUploadData.docInfo.files[0].fileName)
        } else {
            this.docPreviewPopup.message = "<img class='img-responsive auto-height' src='" + this.docUploadData.docInfo.files[0].image + "' alt='" + this.docUploadData.docInfo.files[0].fileName + "'>"
            this.docOverviewModal.show();
        }
    }


    onChange(event) {

        this.file = event.srcElement.files[0];
        if (this.docUploadData.docInfo) {
            this.docService.renderFile(this.file, this.docUploadData.docInfo);
        }
    }

    documentAction(type) {
        let param = {
            type: type,
            docObj: this.file,
            documentSelected: this.docUploadData.docInfo
        }
        this.documentActionEmit.emit(param);
    }

    ngOnChanges(changes: SimpleChanges): void {
        setTimeout(() => {
            this.cameraList = this.camera.toArray();
        }, 100)

    }
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/doc-upload-popup/doc-upload-popup.component.ts